// ---------
// IMPORTANT
// ---------
// Must be kept in sync with /packages/agencies/[agency]/breakpoints.ts
// which is the source-of-truth for chakra's breakpoints
// Right now we only do mobile/desktop so this breakpoint must be
// the desktop number (so that anything below counts as mobile)
// TODO: Stop relying on this and directly get the breakpoint from
// the single source-of-truth
export const CHAKRA_CONFIG = {
  MOBILE_BREAKPOINT: 992, // 62em
};
